import React from 'react';
import { Text, type TextStyle } from 'react-native';
import { AppInput } from './AppInput';
import { DURATION_INPUT_HINT, formatMinutes } from '../utils/dateTime';
import { liveSpreadMinutes } from '../utils/workDuration';

type Props = {
  expectedWorkMinutes: string;
  lunchBreakMinutes: string;
  spreadMinutes: string;
  onExpectedChange: (value: string) => void;
  onLunchChange: (value: string) => void;
  onSpreadChange: (value: string) => void;
  hintStyle: TextStyle;
};

export function WorkDurationFields({
  expectedWorkMinutes,
  lunchBreakMinutes,
  spreadMinutes,
  onExpectedChange,
  onLunchChange,
  onSpreadChange,
  hintStyle,
}: Props) {
  const computedSpread = liveSpreadMinutes(
    expectedWorkMinutes,
    lunchBreakMinutes,
  );

  function syncSpread(nextExpected: string, nextLunch: string) {
    const nextSpread = liveSpreadMinutes(nextExpected, nextLunch);
    onSpreadChange(nextSpread == null ? '' : formatMinutes(nextSpread));
  }

  return (
    <>
      <AppInput
        label="Expected work duration *"
        value={expectedWorkMinutes}
        onChangeText={value => {
          onExpectedChange(value);
          syncSpread(value, lunchBreakMinutes);
        }}
        autoCapitalize="none"
        autoCorrect={false}
        placeholder={DURATION_INPUT_HINT}
      />
      <AppInput
        label="Lunch break duration *"
        value={lunchBreakMinutes}
        onChangeText={value => {
          onLunchChange(value);
          syncSpread(expectedWorkMinutes, value);
        }}
        autoCapitalize="none"
        autoCorrect={false}
        placeholder={DURATION_INPUT_HINT}
      />
      <AppInput
        label="Spread duration *"
        value={spreadMinutes}
        onChangeText={() => undefined}
        editable={false}
        placeholder={DURATION_INPUT_HINT}
      />
      <Text style={hintStyle}>
        {computedSpread == null
          ? 'Spread duration is required. It equals expected work duration + lunch break duration.'
          : `Spread duration is required and equals expected work duration + lunch break duration (${formatMinutes(
              computedSpread,
            )}).`}
      </Text>
    </>
  );
}
